import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter);

import Layout from "@/layout";

export default new VueRouter({
  // mode:"history",
  routes: [
    {
      path: "/index",
      name: 'index',
      component: () => import('@/views/home/Index'),
      meta: {
        title: '成都文化产权交易所-首页',
        content: {
          keywords: '成都文化产权交易所',
          description: '成都文化产权交易所'
        }
      }
    },
    {
    path: '/',
		component: Layout,
		redirect: '/index',
    children:[
      // {
      //   path: "index",
      //   name: 'index',
      //   component: () => import('@/views/Home'),
      //   meta: {
      //     title: '成都文化产权交易所-首页'
      //   }
      // },
      {
        path: "login",
        name: 'login',
        component: () => import('@/views/accountRelated/Login'),
        meta: {
          title: '成都文化产权交易所-登录'
        }
      },
      {
        path: "register",
        name: 'register',
        component: () => import('@/views/accountRelated/Register'),
        meta: {
          title: '成都文化产权交易所-注册'
        }
      },
      {
        path: "newList",
        name: 'newList',
        component: () => import('@/views/news/NewList'),
        meta: {
          title: '成都文化产权交易所-新闻列表'
        }
      },
      {
        path: "PoliciesRegulations",
        name: 'policiesRegulations',
        component: () => import('@/views/news/PoliciesRegulations'),
        meta: {
          title: '成都文化产权交易所-政策法规'
        }
      },
      {
        path: "newDetails",
        name: 'newDetails',
        component: () => import('@/views/news/NewDetails'),
        meta: {
          title: '成都文化产权交易所-新闻详情'
        }
      },
      {
        path: "businessPlatform",
        name: 'businessPlatform',
        component: () => import('@/views/news/businessPlatform'),
        meta: {
          title: '成都文化产权交易所-平台简介'
        }
      },
      {
        path: "user",
        name: 'user',
        component: () => import('@/views/user/Index'),
        meta: {
          title: '成都文化产权交易所-个人中心',
          requireAuth:true
        }
      },
      {
        path: "causeGroup",
        name: 'causeGroup',
        component: () => import('@/views/news/CauseGroup'),
        meta: {
          title: '成都文化产权交易所-事业群'
        }
      },
      {
        path: "aboutUs",
        name: 'aboutUs',
        component: () => import('@/views/user/AboutUs'),
        meta: {
          title: '成都文化产权交易所-关于本所'
        }
      },
      {
        path: "aboutUsNewDetails",
        name: 'aboutUsNewDetails',
        component: () => import('@/views/home/aboutUsNewDetails'),
        meta: {
          title: '成都文化产权交易所-本所要闻详情'
        }
      },{
        path: "biddingProcurementerji",
        name: 'biddingProcurementerji',
        component: () => import('@/views/home/components/biddingProcurementerji'),
        meta: {
          title: '成都文化产权交易所-招标采购'
        }
      },{
        path: "listednoticeerji",
        name: 'listednoticeerji',
        component: () => import('@/views/home/components/listednoticeerji'),
        meta: {
          title: '成都文化产权交易所-挂牌公告'
        }
      },
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/404'),
    hidden: true,
    meta: {headerFlag:'false' }
  },
  { path: '*', redirect: '/404', hidden: true }
  ]
});



// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}



// WEBPACK FOOTER //
// ./src/router/index.js